import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface SoftwareListReq {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 策略id */
  strategy_id?: string
}

export interface SoftwareInfo {
  /** 软件id */
  soft_id: number
  /** 软件名称 */
  soft_name: string
  /** 软件分类名称 */
  soft_group_name: number
  /** 发布日期 */
  publish_time: number
  /** 版本号 */
  soft_version: string
  /** logo url */
  logo_url: string
}

@Injectable()
export class SoftwareListService {
  constructor (private http: Http) {}

  @ParamsClean()
  @InvokeThrottle()
  getSoftwareList (params: SoftwareListReq) {
    return this.http.post<{
      total: number
      name: string
      list: SoftwareInfo[]
    }>('/strategy/soft/list', params)
  }
}
